import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChildren, QueryList, inject } from '@angular/core';
import { Subscription, BehaviorSubject, combineLatest, filter, take } from 'rxjs';

import { AbstractBaseStyleFieldComponent } from '../../../../Common/PageBuilder/components/BaseStyleField/abstract-base-style-field.component';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { BriefingBlockTypeEnum } from '../../../Briefings/enums/briefing-block-type.enum';
import { briefingsStyleDropdownOptions } from '../../../Briefings/models/briefings-style-dropdown-options.model';
import { BriefingStyleStateEnum } from '../../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { MonitoringTextStyleModel } from '../../models/monitoring-text-style.model';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { CheckboxesFieldModel } from '../../../../Common/PageBuilder/models/checkboxes-field.model';
import { CheckboxOptionModel } from '../../../../Common/Forms/models/checkbox-option.model';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { DropdownFieldModel } from '../../../../Common/PageBuilder/models/dropdown-field.model';
import { DropdownOptionModel } from '../../../../Common/Forms/models/dropdown-option.model';
import { FontAlignmentEnum } from '../../../../Common/Forms/enums/font-alignment.enum';
import { ManageStylesDialogComponent } from '../../../../Common/Styles/components/ManageStylesDialog/manage-styles-dialog.component';
import { MentionContentCustomizationEnum } from '../../../../Common/Mentions/enums/mention-content-customization.enum';
import { MentionCustomizationFieldModel } from '../../models/mention-customization-field.model';
import { MentionCustomizationModel } from '../../models/mention-customization.model';
import { MentionMetadataTypesEnum } from '../../enums/mention-metadata-types.enum';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { SaveTwigTemplateDialogComponent } from '../../../../Common/Dialogs/components/SaveTwigTemplateDialog/save-twig-template-dialog.component';
import { SaveTwigTemplateDialogModel } from '../../../../Common/Dialogs/models/save-twig-template-dialog.model';
import { Style } from '../../../../Common/Styles/models/style.model';
import { StylesService } from '../../../../Common/Styles/services/styles.service';
import { StyleTypesApiEnum } from '../../../../api/styles/enum/style-types-api.enum';
import { Template } from '../../../../Common/Styles/models/template.model';
import { TextStyleDefaultsModel } from '../../../../Common/PageBuilder/models/text-style-defaults.model';
import { TextStyleFieldModel } from '../../../../Common/PageBuilder/models/text-style-field.model';
import { MonitorConfigService } from '../../../../Common/MonitorShared/services/monitor-config.service';
import { UserCurrency } from '../../../../Core/Users/enums/user-currency';
import { CurrencyConversionService } from '../../../../Core/Users/services/currency-conversion.service';
import { FullProfileDialogAnimationsEnum } from '../../../../Core/Dialogs/enums/full-profile-dialog-animations.enum';
import { OverlayAnimationStateEnum } from '../../../../Core/Dialogs/enums/overlay-animation.enum';
import { FullProfileAnimationModel } from '../../../../Core/Dialogs/models/full-profile-animation.model';
import { InsightsDisplayNameEnum } from '../../../../Common/Mentions/enums/insights-display-name.enum';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { dateFormats } from '../../../../Core/Users/data/date-formats';
import { BriefingsService } from '../../../Briefings/services/briefings.service';
import { DialogIoModel } from '../../../../Core/Dialogs/models/dialog-io.model';
import { SaveStylesDialogComponent } from '../../../../Common/Dialogs/components/SaveStylesDialog/save-styles-dialog.component';
import { ImageSizeEnum } from '../../enums/image-size.enum';
import { BriefingConfigService } from '../../../../Common/MonitorShared/services/briefing-config.service';
import { BlockDisplayTypeEnum } from '../../../../Common/PageBuilder/enums/block-display-type.enum';
import { MentionCardHeightEnum } from '../../../../Common/Mentions/enums/mention-card-height.enum';
import { UserPreferencesService } from '../../../../Account/UserPreferences/services/user-preferences.service';
import { AdvancedColorPickerFieldModel, backgroundColorConfig } from '@Common/PageBuilder/models/advanced-color-picker-field.model';
import { PanelComponent } from '../../../../Common/Basic/components/Panel/panel.component';

@Component({
    selector: 'agpr-mention-customization-field',
    templateUrl: './mention-customization-field.component.html',
    styleUrls: ['./mention-customization-field.component.scss'],
    standalone: false
})
export class MentionCustomizationFieldComponent extends AbstractBaseStyleFieldComponent implements OnInit, OnChanges, OnDestroy {
    /** Model for managing customizations to mentions */
    @Input() declare value: MentionCustomizationModel;
    @Input() declare field: MentionCustomizationFieldModel;
    @Input() id: string = null;
    @Input() includeNotes: boolean = true;
    @Input() isCanvas: boolean = false; // only used for customizations tab

    checkboxFieldModel: CheckboxesFieldModel;

    styleStateField: DropdownFieldModel;
    sectionHeadingField: TextStyleFieldModel;
    headingField: TextStyleFieldModel;
    snippetFontField: TextStyleFieldModel;
    insightsFontField: TextStyleFieldModel;
    metadataFontField: TextStyleFieldModel;
    notesFontField: TextStyleFieldModel;
    backToTopLinksFontField: TextStyleFieldModel;
    mentionInsightsLinkFontField: TextStyleFieldModel;
    languageFormatField: DropdownFieldModel;
    backgroundColorField: AdvancedColorPickerFieldModel;
    isMentionContentIncluded: boolean;
    underlineLinks: boolean = false;
    highlightKeywords: boolean;
    isFullTextSelected: boolean;
    notes: boolean;
    displayNotesLabel: boolean;
    notesLabel: string;
    includeBackToTopLinks: boolean;
    enforceConcisePlayer: boolean;
    backToTopLinksLabel: string;
    sectionHeading: MonitoringTextStyleModel;
    heading: MonitoringTextStyleModel;
    snippetFont: MonitoringTextStyleModel;
    insightsFont: MonitoringTextStyleModel;
    metadataFont: MonitoringTextStyleModel;
    notesFont: MonitoringTextStyleModel;
    backToTopLinksFont: MonitoringTextStyleModel;
    mentionInsightsLinkFont: MonitoringTextStyleModel;
    dateFormat: string;
    dateFormatOptions: DropdownOptionModel[] = [];
    selectedDateFormat: DropdownOptionModel;
    timezone: string;

    mentionInsightsLinkLabel: string;

    showInsights: boolean;
    displayInsightsName: boolean;
    insightsNameDisplay: InsightsDisplayNameEnum;
    customInsightsName: string;
    insightsDisplayNameEnum = InsightsDisplayNameEnum;
    insightsLinkName: string;
    includeInsightsLink: boolean;
    sectionCollapsed = {
        mentionInsightsLink: true,
        headlines: true,
        snippet: true,
        insights: true,
        metadata: true,
        additional: true,
        padding: true
    };

    showSectionHeading: boolean = true;
    showCardHeight: boolean = true;
    showEngagement: boolean = false;
    showConcisePlayer: boolean = false;
    hideInsights: boolean = false;
    hideMentionInsightsLink: boolean = false;
    isResellerAccount: boolean = false;
    hasMentionInsightsEnabled: boolean = false;

    selectedMentionContentRadioButton: MentionContentCustomizationEnum;
    selectedMentionCardHeightRadioButton: MentionCardHeightEnum;
    selectedMetadataTypes: MentionMetadataTypesEnum[] = [];
    showPublishedDateMetadata: boolean;
    showCurrencySelection: boolean;
    selectedUserCurrency: DropdownOptionModel<UserCurrency>;
    currencyOptions: DropdownOptionModel<UserCurrency>[];
    userCurrency: UserCurrency;
    engagement: boolean = false;
    metadataListExpanded: boolean = false;

    // do not remove, it is being used in AbstractBaseStyleFieldComponent
    isMentionCustomization: boolean = true;

    @ViewChildren(PanelComponent) panels: QueryList<PanelComponent>;

    protected suggestions$: BehaviorSubject<DropdownOptionModel[]> = new BehaviorSubject<DropdownOptionModel[]>([]);
    protected allowEngagementMetadata: boolean = true;

    checkboxOptions: CheckboxOptionModel[] = [
        {
            label: 'Mention.customization.metadataType.mediaType',
            key: MentionMetadataTypesEnum.mediaType
        },
        {
            label: 'Mention.customization.metadataType.outlet',
            key: MentionMetadataTypesEnum.outlet
        },
        {
            label: 'Mention.customization.metadataType.outletIcon',
            key: MentionMetadataTypesEnum.outletIcon
        },
        {
            label: 'Mention.customization.metadataType.author',
            key: MentionMetadataTypesEnum.author
        },
        {
            label: 'Mention.customization.metadataType.audienceReach',
            key: MentionMetadataTypesEnum.audienceReach
        },
        {
            label: 'Mention.customization.metadataType.sentiment',
            key: MentionMetadataTypesEnum.sentiment
        },
        {
            label: 'Mention.customization.metadataType.location',
            key: MentionMetadataTypesEnum.location
        },
        {
            label: 'Mention.customization.metadataType.wordCount',
            key: MentionMetadataTypesEnum.wordCount
        },
        {
            label: 'Mention.customization.metadataType.duration',
            key: MentionMetadataTypesEnum.duration
        },
        {
            label: 'Mention.customization.metadataType.domainAuthority',
            key: MentionMetadataTypesEnum.domainAuthority
        },
        {
            label: 'Mention.customization.metadataType.keywords',
            key: MentionMetadataTypesEnum.keywords,
            disabled: false,
            tooltip: 'Mention.customization.metadataType.keywords.tooltip'
        }
    ];

    readonly buttonTypes = ButtonTypesEnum;
    readonly styleTypes = StyleTypesApiEnum;
    readonly mentionContentCustomization = MentionContentCustomizationEnum;
    readonly mentionCardHeightEnum = MentionCardHeightEnum;
    readonly mentionMetadataTypesEnum = MentionMetadataTypesEnum;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly imageSizeEnum = ImageSizeEnum;
    readonly blockDisplayTypeEnum = BlockDisplayTypeEnum;

    protected saveTwigTemplateDialogModel: SaveTwigTemplateDialogModel = {
        inputs: {
            type: StyleTypesApiEnum.CURATED_MENTION_LIST,
            inputStyle: null
        },
        outputs: {
            dialogClose: (response) => {
                if (response) {
                    this.setStyle(response, 'displayStyleState', true);
                } else {
                    if (this.setTemplate) {
                        this.setTemplate = false;
                        delete this.styleModel.template;
                    }
                }
            }
        }
    };

    defaultStyleStateOptions: DropdownOptionModel[] = briefingsStyleDropdownOptions;
    subscriptions: Subscription[] = [];
    styles: Style[];

    showImageSelection: boolean = false;
    imageSize: ImageSizeEnum;

    briefingConfigService = inject(BriefingConfigService);

    constructor(
        protected coreDialogService: CoreDialogService,
        protected stylesService: StylesService,
        protected monitorConfigService: MonitorConfigService,
        public briefingsService: AbstractPageBuilderService,
        protected currentUserStateService: CurrentUserStateService,
        protected currencyConversionService: CurrencyConversionService,
        protected localizationService: LocalizationService,
        protected configService: ConfigService,
        protected userPreferencesService: UserPreferencesService,
    ) {
        super(coreDialogService);
        this.isResellerAccount = configService.hasBrandGUID() && !configService.brandGUIDIsPaMedia();
        this.dateFormatOptions = dateFormats.map(format => new DropdownOptionModel(this.localizationService.transform(format.name), format));

        this.subscriptions.push(
            this.stylesService.all$.pipe(
                filter(x => !!x)
            ).subscribe(styles => {
                this.styles = styles;

                this.updateStyleOptions();
                this.updateStyleFromSavedStyle();
            }),
            combineLatest([
                this.monitorConfigService.getCriticalMentionEnabled(),
                this.monitorConfigService.getTvEyesEnabled()
            ]).subscribe(([hasCriticalMention, hasTvEyes]) => {
                this.showConcisePlayer = hasCriticalMention || hasTvEyes;
            }),
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(pref => {
                if (pref){
                    this.userCurrency = pref.currency;
                    if (this.value?.dateFormat) {
                        this.selectedDateFormat = this.dateFormatOptions.find(option => option.value.momentFormat === this.value.dateFormat);
                    } else {
                        this.selectedDateFormat = this.dateFormatOptions.find(option => option.value.id === pref.dateFormatId);
                        this.dateFormat = this.selectedDateFormat.value.momentFormat;
                        if (!this.value) {
                            this.value = new MentionCustomizationModel();
                            this.setSelectedMetadataTypes();
                        }
                        this.value.dateFormat = this.dateFormat;
                    }
                }
            }),
            this.monitorConfigService.getHasMentionInsightsEnabled().subscribe(x => this.hasMentionInsightsEnabled = x),
            this.currentUserStateService.getUser().pipe(filter(x => !!x)).subscribe(user => {
                this.internalUser = user.internal;
            }),
            (this.briefingsService as BriefingsService).getUpdatedAutomaticBlock().subscribe((currentAutomaticBlock) => {
                this.showInsights = currentAutomaticBlock?.displayElement?.styles.showInsights;
                this.value.showInsights = this.showInsights;
            }),
            this.briefingConfigService.getConfig().pipe(filter(x => !!x)).subscribe(config => {
                this.showEngagement = config.hasEngagementUpdates;
            }),
            this.userPreferencesService.getUILanguages().pipe(filter(x => !!x),take(1)).subscribe(languages => {
                const languageFormatOptions = languages.map(x =>
                    new DropdownOptionModel(this.localizationService.transform(`Language.${x.languageTag}`), x.languageTag)
                ).sort((a, b) => a.label.localeCompare(b.label));

                this.languageFormatField = new DropdownFieldModel(
                    null,
                    'locale',
                    'DateStyleField.language',
                    null,
                    languageFormatOptions
                );
            })
        );
        this.currencyOptions = this.currencyConversionService.getCurrencyDropdownOptions();
        this.suggestions$.next(this.currencyOptions);
    }

    ngOnInit() {
        if (this.block?.displayElement) {
            this.field.allowExpertMode = this.block?.displayElement?.displayType !== BlockDisplayTypeEnum.ONLINE;
        }

        if (!this.value) {
            this.value = new MentionCustomizationModel();
            this.setSelectedMetadataTypes();
        }

        if (this.field.changeDefaultStyleStateOptions) {
            this.defaultStyleStateOptions = this.field.changeDefaultStyleStateOptions(this);
        }
        this.styleStateField = new DropdownFieldModel(
            null,
            'displayStyleState',
            'PageBuilder.styles.contentBlockStyle',
            '',
            [
                { label: 'Briefings.formField.styles.defaultAgilityStyleOne', value: BriefingStyleStateEnum.BRIEFING_1 },
                { label: 'Briefings.formField.styles.defaultAgilityStyleTwo', value: BriefingStyleStateEnum.BRIEFING_2 },
                { label: 'Briefings.formField.styles.defaultAgilityStyleThree', value: BriefingStyleStateEnum.BRIEFING_3 },
                { label: 'Briefings.formField.styles.defaultAgilityCanvasOne', value: BriefingStyleStateEnum.CANVAS_1 },
                { label: 'Briefings.formField.styles.custom', value: BriefingStyleStateEnum.CUSTOM }
            ]
        );
        this.styleStateField.labelStyleClass = 'agpr-mentionCustomization-styleStateLabel';
        this.updateStyleOptions();

        this.sectionHeadingField = new TextStyleFieldModel(
            'sectionHeading',
            false,
            new TextStyleDefaultsModel(
                '20px',
                '#292929',
                true
            ),
            'Briefing.textStyle.sectionHeading.label'
        );

        this.headingField = new TextStyleFieldModel(
            'heading',
            false,
            new TextStyleDefaultsModel(
                '16px',
                '#005494',
                true
            ),
            'Briefing.textStyle.heading.label'
        );

        this.snippetFontField = new TextStyleFieldModel(
            'snippetFont',
            false,
            new TextStyleDefaultsModel(
                '14px',
                '#292929',
                false
            ),
            null,
            null,
            false
        );

        this.insightsFontField = new TextStyleFieldModel(
            'insightsFont',
            false,
            new TextStyleDefaultsModel(
                '14px',
                '#292929',
                true
            ),
            null,
            null,
            true
        );

        this.metadataFontField = new TextStyleFieldModel(
            'metadataFont',
            false,
            new TextStyleDefaultsModel(
                '12px',
                '#5e6473',
                false,
                false,
                null
            ),
            null,
            null,
            false,
        );

        this.notesFontField = new TextStyleFieldModel(
            'notesFont',
            false,
            new TextStyleDefaultsModel(
                '12px',
                '#5e6473',
                false
            ),
            null,
            null,
            false
        );

        this.backToTopLinksFontField = new TextStyleFieldModel(
            'backToTopLinksFont',
            false,
            new TextStyleDefaultsModel(
                '12px',
                '#5e6473',
                true,
                true,
                FontAlignmentEnum.right
            ),
            null,
            null,
            true
        );

        this.mentionInsightsLinkFontField = new TextStyleFieldModel(
            'mentionInsightsLinkFont',
            false,
            new TextStyleDefaultsModel(
                '12px',
                '#5e6473',
                true,
                true,
                null
            ),
            null,
            null,
            null
        );

        this.checkboxFieldModel = new CheckboxesFieldModel(
            null,
            'metaDataItems',
            null,
            null,
            this.checkboxOptions
        );

        this.backgroundColorField = AdvancedColorPickerFieldModel.create(backgroundColorConfig(true));


        if (this.field.includeNotes !== undefined) {
            this.includeNotes = this.field.includeNotes;
        }
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes.hasOwnProperty('value')) {
            if (!this.value) {
                return;
            }

            this.setSelectedMetadataTypes();
            this.setselectedMentionContentRadioButton();
            this.setMentionCardHeightRadioButton();
            this.sectionHeading = this.value.sectionHeading;
            this.includeBackToTopLinks = this.value.includeBackToTopLinks;
            this.enforceConcisePlayer = this.value.enforceConcisePlayer;
            this.highlightKeywords = this.value.highlightKeywords;
            this.notes = this.value.notes;
            this.displayNotesLabel = this.value.displayNotesLabel;
            this.notesLabel = this.value.notesLabel;
            this.backToTopLinksLabel = this.value.backToTopLinksLabel;
            this.heading = this.value.heading;
            this.snippetFont = this.value.snippetFont;
            this.insightsFont = this.value.insightsFont;
            this.metadataFont = this.value.metadataFont;
            this.notesFont = this.value.notesFont;
            this.backToTopLinksFont = this.value.backToTopLinksFont;
            this.mentionInsightsLinkFont = this.value.mentionInsightsLinkFont;
            this.mentionInsightsLinkLabel = this.value.mentionInsightsLinkLabel;
            this.underlineLinks = this.value.underlineLinks;
            this.showSectionHeading = this.value.showSectionHeading ?? true;
            this.showInsights = this.value.showInsights;
            this.displayInsightsName = this.value.displayInsightsName;
            this.insightsNameDisplay = this.value.insightsNameDisplay;
            if (this.value.customInsightsName) {
                this.customInsightsName = this.value.customInsightsName;
            }

            // init the value of the separate metadata option for published date
            this.showPublishedDateMetadata = this.value.metadataTypes.indexOf(MentionMetadataTypesEnum.publishedDate) !== -1;
            this.timezone = this.value.timezone;
            if (this.value.dateFormat) {
                this.dateFormat = this.value.dateFormat;
                this.selectedDateFormat = this.dateFormatOptions.find(option => option.value.momentFormat === this.value.dateFormat);
            }

            if (this.value.preferredCurrency) {
                this.selectedUserCurrency = this.currencyOptions.find(option => option.value === this.value.preferredCurrency);
            } else if (this.userCurrency) {
                this.selectedUserCurrency = this.currencyOptions.find(option => option.value === this.userCurrency);
                this.value.preferredCurrency = this.userCurrency;
                this.value.currencyRate = this.currencyConversionService.getCurrencyRate(this.userCurrency);
            }

            this.showCurrencySelection = this.value.metadataTypes.indexOf(MentionMetadataTypesEnum.ave) !== -1;
            this.engagement = this.value.metadataTypes.includes(MentionMetadataTypesEnum.engagement);

            this.showImageSelection = this.value.image;
            if (Object.values(ImageSizeEnum).includes(this.value.imageSize)) {
                this.imageSize = this.value.imageSize;
            }

            this.updateStyleOptions();
        }
    }


    setCustomStyleState(setDefaultReference: boolean = false) {
        if (!this.value.isSavedStyle() || !this.internalUser) {
            this.value.displayStyleState = BriefingStyleStateEnum.CUSTOM;
            if (setDefaultReference) {
                this.value.styleState = this.value.getDefaultReference();
                delete this.value.defaultReference;
            }
        }
    }

    /**
     * Handles change to headline customization property
     */
    toggleMentionContentIncluded(): void {
        if (this.isMentionContentIncluded) {
            this.selectedMentionContentRadioButton = MentionContentCustomizationEnum.lead;
            this.mentionSnippetChange(MentionContentCustomizationEnum.lead);
        } else {
            this.selectedMentionContentRadioButton = MentionContentCustomizationEnum.headlineOnly;
            this.mentionSnippetChange(MentionContentCustomizationEnum.headlineOnly);
        }
    }

    underlineLinksChange() {
        this.value.underlineLinks = this.underlineLinks;
        this.setCustomStyleState();
        this.emitChanges();
    }

    showSectionHeadingChange(): void {
        this.setCustomStyleState(true);
        this.value.showSectionHeading = this.showSectionHeading;
        this.emitChanges();
    }

    /**
     * Handles changes to the mention's snippet
     */
    mentionSnippetChange(mentionCustomizationEnum: MentionContentCustomizationEnum) {
        this.value.mentionContent = mentionCustomizationEnum;

        if (this.value.mentionContent === MentionContentCustomizationEnum.fullText) {

            if (!this.isFullTextSelected) {
                this.value.mentionContent = MentionContentCustomizationEnum.lead;
            }

        } else {
            this.isFullTextSelected = false;
        }
        this.setCustomStyleState();

        this.emitChanges();
    }

    /**
     * Handles changes to the mention's snippet
     */
    mentionCardHeightChange(mentionCardHeightEnum: MentionCardHeightEnum) {
        this.value.cardHeight = mentionCardHeightEnum;

        this.setCustomStyleState();

        this.emitChanges();
    }

    showInsightChange() {
        this.value.showInsights = this.showInsights;
        this.setCustomStyleState();
        this.emitChanges();
    }

    insightsNameDisplayChange() {
        this.value.displayInsightsName = this.displayInsightsName;

        if (this.displayInsightsName && !this.insightsNameDisplay) {
            this.insightsNameDisplay = InsightsDisplayNameEnum.insightsName;
        }

        this.setCustomStyleState();
        this.emitChanges();
    }
    insightsNameChange() {
        this.value.insightsNameDisplay = this.insightsNameDisplay;
        if (this.value.insightsNameDisplay === InsightsDisplayNameEnum.custom && !this.customInsightsName) {
            this.customInsightsName = this.localizationService.transform('Mention.customization.defaultInsightName');
        }

        this.setCustomStyleState();
        this.emitChanges();
    }
    customInsightsNameChange() {
        this.value.customInsightsName = this.customInsightsName;
        this.setCustomStyleState();
        this.emitChanges();
    }

    /**
     * Handles change in mention metadata
     */
    mentionMetadataChange(event: MentionMetadataTypesEnum[]): void {
        this.selectedMetadataTypes = event;
        this.value.setMetadataTypes(event);

        this.setCustomStyleState(true);
        this.emitChanges();
    }

    /*
     * Handles changes to checkbox for including/excluding mention's notes
     */
    toggleNotes(): void {
        this.setCustomStyleState(true);
        this.value.notes = this.notes;
        this.emitChanges();
    }

    /*
     * Handles changes to checkbox for including/excluding mention's notes label
     */
    toggleDisplayNotes(): void {
        this.setCustomStyleState(true);
        this.value.displayNotesLabel = this.displayNotesLabel;
        this.emitChanges();
    }

    toggleIncludeBackToTopLinks(): void {
        this.setCustomStyleState(true);
        delete this.value.includeBackToTopLinks;
        this.value.includeBackToTopLinks = this.includeBackToTopLinks;
        this.emitChanges();
    }

    toggleHighlightKeywords(): void {
        this.setCustomStyleState(true);
        // delete this.value.highlightKeywords;
        this.value.highlightKeywords = this.highlightKeywords;
        this.emitChanges();
    }

    toggleEnforceConcisePlayer(): void {
        this.setCustomStyleState(true);
        this.value.enforceConcisePlayer = this.enforceConcisePlayer;
        this.emitChanges();
    }

    imageSizeChanged(imageSize: ImageSizeEnum) {
        this.imageSize = imageSize;
        this.setCustomStyleState(true);
        this.value.imageSize = imageSize;
        this.emitChanges();
    }

    toggleImageSelection(event: boolean): void{
        this.showImageSelection = event;
        if (event) {
            if (this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.image) === -1) {
                this.selectedMetadataTypes.push(MentionMetadataTypesEnum.image);
            }
            this.imageSizeChanged(ImageSizeEnum.fullWidth);
        } else {
            const index = this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.image);
            if (index > -1) {
                this.selectedMetadataTypes.splice(index, 1);
            }
            this.imageSizeChanged(null);
        }
        this.mentionMetadataChange(this.selectedMetadataTypes);
    }

    toggleEngagement(event: boolean) {
        if (event) {
            if (this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.engagement) === -1) {
                this.selectedMetadataTypes.push(MentionMetadataTypesEnum.engagement);
            }
        } else {
            const index = this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.engagement);
            if (index > -1) {
                this.selectedMetadataTypes.splice(index, 1);
            }
        }
        this.mentionMetadataChange(this.selectedMetadataTypes);
    }

    toggleAVE(event): void {
        this.showCurrencySelection = event;
        if (event) {
            if (this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.ave) === -1) {
                this.selectedMetadataTypes.push(MentionMetadataTypesEnum.ave);
            }
        } else {
            const index = this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.ave, 0);
            if (index > -1) {
                this.selectedMetadataTypes.splice(index, 1);
            }
        }
        this.mentionMetadataChange(this.selectedMetadataTypes);
    }

    /**
     * In this case, the event is true or false, for if we should show publishedDate in the metadata
     *
     * @param event boolean
     */
    showPublishedDateMetadataChanged(event): void {
        this.showPublishedDateMetadata = event;
        if (event) {
            if (this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.publishedDate) === -1) {
                this.selectedMetadataTypes.push(MentionMetadataTypesEnum.publishedDate);
            }
        } else {
            const index = this.selectedMetadataTypes.indexOf(MentionMetadataTypesEnum.publishedDate);
            if (index > -1) {
                this.selectedMetadataTypes.splice(index, 1);
            }
        }
        this.mentionMetadataChange(this.selectedMetadataTypes);
    }

    setBackToTopLinksLabel(): void {
        this.setCustomStyleState(true);
        this.value.backToTopLinksLabel = this.backToTopLinksLabel;
        this.emitChanges();
    }

    /*
     * Handles changes the mention's notes label
     */
    setNotesLabel(): void {
        this.setCustomStyleState(true);
        this.value.notesLabel = this.notesLabel;
        this.emitChanges();
    }

    setMentionInsightsLinkLabel(): void {
        this.setCustomStyleState();
        this.value.mentionInsightsLinkLabel = this.mentionInsightsLinkLabel;
        this.emitChanges();
    }

    get metadataSelectedCount(): number {
        return this.selectedMetadataTypes?.length ?? 0;
    }

    toggleMetadataList(): void {
        this.metadataListExpanded = !this.metadataListExpanded;
    }

    metadataToggleKeydown(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.toggleMetadataList();
        }
    }

    get showHeadlinesSection(): boolean {
        return true;
    }

    get showInsightsSection(): boolean {
        return !this.hideInsights && !this.isResellerAccount;
    }

    get showMentionInsightsLinkSection(): boolean {
        return !this.hideMentionInsightsLink
            && !this.isResellerAccount
            && this.block?.displayElement?.displayType !== BlockDisplayTypeEnum.ONLINE;
    }

    get hasExpandedSections(): boolean {
        return this.getVisibleSectionCollapsedStates().some(state => !state);
    }

    get toggleAllLabel(): string {
        return this.hasExpandedSections
            ? 'Mention.customization.collapseAll'
            : 'Mention.customization.expandAll';
    }

    toggleAllSections(): void {
        const shouldCollapse = this.hasExpandedSections;
        this.setAllSectionsCollapsed(shouldCollapse);
        this.syncPanelStates(shouldCollapse);
    }

    private setAllSectionsCollapsed(collapsed: boolean): void {
        if (this.showMentionInsightsLinkSection) {
            this.sectionCollapsed.mentionInsightsLink = collapsed;
        }
        if (this.showHeadlinesSection) {
            this.sectionCollapsed.headlines = collapsed;
        }
        this.sectionCollapsed.snippet = collapsed;
        if (this.showInsightsSection) {
            this.sectionCollapsed.insights = collapsed;
        }
        this.sectionCollapsed.metadata = collapsed;
        this.sectionCollapsed.additional = collapsed;
        this.sectionCollapsed.padding = collapsed;
    }

    private getVisibleSectionCollapsedStates(): boolean[] {
        const states: boolean[] = [];
        if (this.showMentionInsightsLinkSection) {
            states.push(this.sectionCollapsed.mentionInsightsLink);
        }
        if (this.showHeadlinesSection) {
            states.push(this.sectionCollapsed.headlines);
        }
        states.push(this.sectionCollapsed.snippet);
        if (this.showInsightsSection) {
            states.push(this.sectionCollapsed.insights);
        }
        states.push(this.sectionCollapsed.metadata);
        states.push(this.sectionCollapsed.additional);
        states.push(this.sectionCollapsed.padding);

        return states;
    }

    private syncPanelStates(collapsed: boolean): void {
        if (!this.panels?.length) {
            return;
        }

        this.panels.forEach(panel => {
            if (collapsed) {
                panel.collapse(null);
            } else {
                panel.expand(null);
            }
        });
    }

    dateFormatChanged(option: DropdownOptionModel) {
        this.setCustomStyleState();
        delete this.value.dateFormat;
        this.dateFormat = option.value.momentFormat;
        this.value.dateFormat = this.dateFormat;
        this.emitChanges();
    }

    timezoneChanged(timezone): void {
        this.setCustomStyleState(true);
        delete this.value.timezone;
        this.timezone = timezone;
        this.value.timezone = this.timezone;
        this.emitChanges();
    }

    currencyChanged(event: DropdownOptionModel){
        this.setCustomStyleState(true);
        delete this.value.preferredCurrency;
        delete this.value.currencyRate;
        this.userCurrency = event.value;
        this.value.preferredCurrency = this.userCurrency;
        this.value.currencyRate = this.currencyConversionService.getCurrencyRate(this.userCurrency);
        this.emitChanges();
    }

    emitChanges() {
        this.changes.emit(this.value);
    }

    /**
     * Sets selected mention content from value
     */
    setselectedMentionContentRadioButton() {
        if (!this.value) {
            return;
        }

        if (!this.value.mentionContent) {
            this.isMentionContentIncluded = true;
            this.selectedMentionContentRadioButton = MentionContentCustomizationEnum.lead;
            this.isFullTextSelected = false;
            this.value.mentionContent = MentionContentCustomizationEnum.lead;
        } else {
            this.isMentionContentIncluded = true;
            this.isFullTextSelected = false;
            this.selectedMentionContentRadioButton = this.value.mentionContent;

            switch (this.selectedMentionContentRadioButton) {
                case MentionContentCustomizationEnum.headlineOnly:
                    this.isMentionContentIncluded = false;
                    break;
                case MentionContentCustomizationEnum.fullText:
                    this.isFullTextSelected = true;
                    this.selectedMentionContentRadioButton = MentionContentCustomizationEnum.lead;
                    break;
                case MentionContentCustomizationEnum.lead:
                    break;
                case MentionContentCustomizationEnum.summary:
                    break;
            }
        }
    }

    /**
     * Sets selected mention card height from value
     */
    setMentionCardHeightRadioButton() {
        if (!this.value) {
            return;
        }
        if (!this.value.cardHeight) {
            this.selectedMentionCardHeightRadioButton = MentionCardHeightEnum.fixed;
        } else {
            this.selectedMentionCardHeightRadioButton = this.value.cardHeight;
        }
    }

    /**
     * Sets the selected metadataTypes
     */
    setSelectedMetadataTypes(): void {
        if (!this.value) {
            return;
        }

        const metaDataTypes = new Set(this.value.metadataTypes);

        if (this.value.mediaType) {
            metaDataTypes.add(MentionMetadataTypesEnum.mediaType);
        }

        if (this.value.outletIcon) {
            metaDataTypes.add(MentionMetadataTypesEnum.outletIcon);
        }

        this.selectedMetadataTypes = [...metaDataTypes];
    }

    /**
     * Opens the save-twig-template-dialog after loading the data needed for it
     */
    public saveExpertTemplate(): void {
        if (!this.styleModel) {
            this.styleModel = new Style();
        }

        this.styleModel.style = this.value;
        this.styleModel.template = this.value.template;
        this.saveTwigTemplateDialogModel.inputs.defaultTemplate =
            this.briefingsService.getDefaultTemplateByBlockType(
                BriefingBlockTypeEnum.CURATED_MENTION_LIST,
                BriefingStyleStateEnum.BRIEFING_1
            );
        // Set the default template if there's not a template on this style already
        if (!this.styleModel.template) {
            this.styleModel.template = new Template();
            this.styleModel.template.template = this.saveTwigTemplateDialogModel.inputs.defaultTemplate;
        }

        this.saveTwigTemplateDialogModel.inputs.inputStyle = this.styleModel;
        const dialogKey = this.coreDialogService.open(SaveTwigTemplateDialogComponent, this.saveTwigTemplateDialogModel);
    }

    protected updateStyleFromSavedStyle() {
        if (!this.value || !this.styles || !Number(this.value.styleState)) {
            return;
        }
        const savedStyle: Style = this.styles.find(x => x.id === this.value.styleState as number);
        if (!savedStyle) {
            // the list doesn't contain the id we're looking for, can't load it
            return;
        }
        const mentionStyleModel = new MentionCustomizationModel(savedStyle.style);
        mentionStyleModel.styleState = this.value.styleState;
        mentionStyleModel.displayStyleState = this.value.displayStyleState;
        mentionStyleModel.template = savedStyle.template;

        this.value = mentionStyleModel;
    }

    public manageStylesButtonClicked(): void {
        const overlayContainer = document.getElementById('main-content');
        const animationTrigger = new BehaviorSubject(
            new FullProfileAnimationModel(
                FullProfileDialogAnimationsEnum.slideInOutAnimation,
                OverlayAnimationStateEnum.open
            )
        );
        const io = {
            inputs: {
                animationTrigger: animationTrigger,
                overlayContainer: overlayContainer
            }
        };
        this.coreDialogService.open(ManageStylesDialogComponent, io);
    }

    public saveMentionStyle(): void {
        if (!this.styleModel) {
            this.styleModel = new Style();
        }

        this.styleModel.style = this.value;

        const io: DialogIoModel = {
            inputs: {
                type: StyleTypesApiEnum.CURATED_MENTION_LIST,
                inputStyle: this.styleModel
            },
            outputs: {
                dialogClose: (response) => {
                    if (response) {
                        this.setStyle(response, 'displayStyleState', true);
                    }
                }
            }
        };

        this.coreDialogService.open(SaveStylesDialogComponent, io);
    }

    protected updateStyleOptions(): void {
        if (!this.styles || !this.value || !this.value.styleState || !this.styleStateField) {
            return;
        }
        if (this.field.changeDefaultStyleStateOptions) {
            this.defaultStyleStateOptions = this.field.changeDefaultStyleStateOptions(this);
        }
        const styleDropdownOptions = this.styles.filter(
            style => (
                style.type === StyleTypesApiEnum.CURATED_MENTION_LIST ||
                style.type === StyleTypesApiEnum.AUTOMATIC_MENTION_LIST ||
                style.type === StyleTypesApiEnum.ALERT
            )
        ).map(
            style => {
                return {
                    label: style.name,
                    value: style.id
                };
            }
        );

        this.styleStateField.options = [
            ...this.defaultStyleStateOptions,
            ...styleDropdownOptions
        ];
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
